import type { TOC } from '@ember/component/template-only';

const SettingsRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default SettingsRouteTemplate;
